interface IFooterNavButton {
  href: string;
  label: string;
}

const FooterNavButton = ({ href, label }: IFooterNavButton) => {
  // rendering footer nav button component here
  return (
    <li className="group relative w-full pr-2 md:w-fit">
      <a
        href={href}
        className="font-semibold text-legal-light-gray duration-300 group-hover:text-legal-white"
      >
        {label}
      </a>

      <div className="absolute hidden h-[2px] w-0 bg-legal-brown duration-300 group-hover:w-full md:block"></div>
    </li>
  );
};

export default FooterNavButton;
